var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RankingList',{staticClass:"cms-block",attrs:{"elements":_vm.block.value.rows,"show-avatar":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }